/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
// import Select from 'react-select';
// import * as find from 'lodash/find';
// import * as sortBy from 'lodash/sortBy';
import '../css/About.css';
import '../css/AddVehicle.css';
import { Row } from 'react-bootstrap';
// import MyUtil from '../../functions/MyUtil';
import ModuleApi from '../../functions/api/user/ModuleApi';
import NotifyAlert from '../../components/Notify/NotifyAlert';
import ConvertModule from '../../functions/ConvertModule';
import NotifyError from '../../components/Notify/NotifyError';
// import moment from 'moment'
// import debounce from "lodash.debounce";

class FormAddModule extends Component {
  constructor(props) {
    super(props);
    this.state = {
      module_id: '',
      module_name: '',
      description: '',
      route_path: '',
      isEdit: false,
    };
  }

  componentDidMount = async () => {
    const { match } = this.props;

    if (match.params && match.path === '/module/edit/:module_id') {
      const { module_id: moduleId } = match.params;
      const module = await ModuleApi.getOne(moduleId);
      console.log('module ', module);
      const { module_id, module_name, description, route_path } = module;
      this.setState({
        isEdit: true,
        module_id,
        module_name,
        description,
        route_path,
      });
    }
  };

  handleChange = async (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  clearForm = () => {
    this.setState({
      module_id: '',
      module_name: '',
      description: '',
      route_path: '',
    });
  };

  handleCreate = async () => {
    const { check } = ConvertModule.handleCheck(this.state);
    const { isEdit } = this.state;
    if (!check) {
      let result = '';
      if (isEdit) {
        const module = ConvertModule.handleUpdate(this.state);
        result = await ModuleApi.update(module);
      } else {
        const module = ConvertModule.handleNew(this.state);
        result = await ModuleApi.create(module);
      }

      console.log('result ', result);
      if (result && !result.message) {
        let message = '';
        if (isEdit) message = 'Sửa module thành công!';
        else message = 'Thêm module thành công';

        NotifyAlert('Thành công', message);
        if (!isEdit) this.clearForm();
      } else {
        NotifyError('Lỗi', result.message);
      }
    } else {
      NotifyAlert('Thông báo', `Dữ liệu bạn nhập bị thiếu. Hãy kiểm tra lại.`);
    }
  };

  render() {
    const { module_name, description, route_path, isEdit } = this.state;
    return (
      <div>
        <div
          style={{
            display: 'inline-flex',
            width: '90%',
            margin: '10px 10px 20px 21px',
          }}
        >
          <Link to="/module">
            <div className="button-back button">
              <img
                alt="Quay lại"
                src="ic_back.png"
                style={{ height: '20px' }}
              />
              <div style={{ fontSize: '16px' }}>Quay lại</div>
            </div>
          </Link>
          <div
            style={{
              color: '#107d82',
              fontWeight: '600',
              fontSize: '20px',
              marginLeft: '30%',
            }}
          >
            {isEdit ? 'Sửa module' : 'Thêm module'}
          </div>
        </div>

        <div
          style={{ backgroundColor: '#ececec', margin: '5px 20px 20px 20px' }}
        >
          <Row className="row-form">
            <div className="row-child row-child-small">
              <div className="title-content-page">Module Name</div>
              <input
                className="input-normal full-width"
                onChange={this.handleChange}
                name="module_name"
                value={module_name}
                placeholder="Nhập vào module name"
              />
            </div>

            <div className="row-child row-child-small">
              <div className="title-content-page">Mô tả</div>
              <input
                className="input-normal full-width"
                onChange={this.handleChange}
                name="description"
                value={description}
                placeholder="Nhập vào mô tả"
              />
            </div>

            <div className="row-child row-child-small">
              <div className="title-content-page">Route Path</div>
              <input
                className="input-normal full-width"
                onChange={this.handleChange}
                name="route_path"
                value={route_path}
                placeholder="Nhập vào route path"
              />
            </div>
          </Row>
        </div>

        <Row
          style={{
            display: 'inline-flex',
            width: '100%',
            marginBottom: '30px',
          }}
        >
          <button
            type="button"
            className="btn-edit button btn-save"
            style={{ background: '#107d82' }}
            onClick={this.handleCreate}
          >
            Lưu thay đổi
          </button>
        </Row>
      </div>
    );
  }
}

export default FormAddModule;
